/**
 * 生产环境、测试环境、开发环境
 */

export default {
  path() {
    let path = '/api';
    // switch (VUE_APP_NODE_ENV) {
    //   case "production":
    //     // todo 生产环境
    //     path = "https://mlzd.luoex.xin:8000";
    //     break;
    //   case "preview":
    //     // todo 预演环境
    //     path = 'http://10.5.4.144:12001';
    //     break;
    //   case "test":
    //     // todo 测试环境
    //     path = 'http://10.5.4.162:12001';
    //     break;
    //   case "development":
    //     // todo 开发环境
    //     path = "http://10.5.4.145:9900";
    //     break;
    //   default:
    //     // todo 开发环境
    //      path = "http://10.5.4.145:9900";
    //     break;
    // }
    return { path };
  }
};
